/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free strong password generator. Create random, secure passwords in your browser with custom length and character sets. Nothing is sent anywhere.`)
};

const es_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de contraseñas fuerte y gratuito. Crea contraseñas aleatorias y seguras en tu navegador con longitud y conjuntos de caracteres personalizados. Nada se envía a ningún lado.`)
};

const de_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Passwortgenerator. Erstellen Sie sichere Zufallspasswörter in Ihrem Browser mit benutzerdefinierter Länge und Zeichensätzen. Nichts wird jemals gesendet.`)
};

const nl_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis sterke wachtwoordgenerator. Creëer willekeurige, veilige wachtwoorden in je browser met aangepaste lengte en tekensets. Niets wordt ergens verzonden.`)
};

const fr_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de mot de passe fort gratuit. Créez des mots de passe aléatoires sécurisés dans votre navigateur avec longueur personnalisée et ensembles de caractères. Rien n'est envoyé nulle part.`)
};

const it_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di password forte gratuito. Crea password casuali e sicure nel tuo browser con lunghezza e set di caratteri personalizzati. Nulla viene inviato da nessuna parte.`)
};

const pt_br2_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de senhas seguras gratuito. Crie senhas aleatórias e seguras em seu navegador com comprimento e conjuntos de caracteres personalizados. Nada é enviado para lugar nenhum.`)
};

const pt_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de senhas forte e gratuito. Crie senhas aleatórias e seguras no seu navegador com comprimento e conjuntos de caracteres personalizados. Nada é enviado para lado nenhum.`)
};

const ja_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の強力なパスワードジェネレーター。カスタム長と文字セットを使用してブラウザで安全なランダムパスワードを作成できます。何もどこにも送信されません。`)
};

const zh_pw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的强密码生成器。在浏览器中创建具有自定义长度和字符集的随机安全密码。不会向任何地方发送任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_tool_description", locale)
	if (locale === "en") return en_pw_tool_description(inputs)
	if (locale === "es") return es_pw_tool_description(inputs)
	if (locale === "de") return de_pw_tool_description(inputs)
	if (locale === "nl") return nl_pw_tool_description(inputs)
	if (locale === "fr") return fr_pw_tool_description(inputs)
	if (locale === "it") return it_pw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_pw_tool_description(inputs)
	if (locale === "pt") return pt_pw_tool_description(inputs)
	if (locale === "ja") return ja_pw_tool_description(inputs)
	return zh_pw_tool_description(inputs)
};